import { gaEvent } from './gaEvent';

const gaTracking = (category, label, context) => {
  const action = 'From ' + context + ' in ' + window.location.pathname;
  gaEvent(category, action, label);
};

export default gaTracking;
